import numeral from "numeral";

export default function formatMoneyValueOnlyDigits(value: number) {
  return numeral(value).format("0,0").replace(/,/g, ".");
}
